<template>
  <v-card class="d-flex flex-column">
    <div class="px-7 pt-5">
      <div class="header">
        <div class="d-flex justify-space-between align-center">
          <h2>Riwayat Pemeriksaan Laboratorium</h2>
          <v-btn @click="close" text fab small dense depressed
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </div>
        <div class="d-flex align-center mt-1">
          <p>No RM</p>
          <p>{{ patientData.rmNumber }}</p>
          <p>Nama</p>
          <p>{{ patientData.name }} ({{ patientData.gender ? 'L' : 'P' }})</p>
          <p>Tanggal Lahir</p>
          <p>{{ patientData.birthDate }} ({{ patientData.age }})</p>
        </div>
      </div>
    </div>
    <v-divider />
    <div class="d-flex justify-space-between align-center pt-4 px-7">
      <div class="d-flex align-center">
        <v-combobox
          append-icon="mdi-chevron-down"
          class="mr-2"
          placeholder="Pilih filter"
          dense
          outlined
          single-line
          hide-details
          @change="onChangeTimeType"
          :items="resource.timeType"
          v-model="filters.timeType"
        />
        <!-- v-if="filters.timeType !== 'Semua Waktu'" -->
        <v-menu
          dense
          ref="menu_startdate"
          v-model="menu.startDate"
          v-if="filters.timeType !== 'Semua Waktu'"
          :close-on-content-click="false"
          :return-value.sync="filters.startDate.formatted"
          :disabled="isDisabledDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              flat
              single-line
              solo
              outlined
              readonly
              hide-details
              :background-color="isDisabledDate ? 'grey lighten-3' : ''"
              class="mr-2"
              v-bind="attrs"
              :disabled="isDisabledDate"
              v-on="on"
              v-model="filters.startDate.formatted"
              prepend-inner-icon="mdi-calendar"
              placeholder="Pilih tanggal"
            />
          </template>
          <!-- :max="filter.type === 'Rentang Tanggal' ? endDate.raw : ''" -->
          <v-date-picker
            v-model="filters.startDate.raw"
            locale="id"
            scrollable
            @input="
              $refs.menu_startdate.save(formatDate(filters.startDate.raw))
            "
          ></v-date-picker>
        </v-menu>
        <span
          v-if="
            filters.timeType !== 'Semua Waktu' &&
              filters.timeType !== 'Per Tanggal'
          "
          class="caption"
        >
          s.d.
        </span>
        <v-menu
          dense
          ref="menu_enddate"
          v-model="menu.endDate"
          :close-on-content-click="false"
          :disabled="isDisabledDate"
          :return-value.sync="filters.endDate.formatted"
          transition="scale-transition"
          offset-y
          v-if="
            filters.timeType !== 'Semua Waktu' &&
              filters.timeType !== 'Per Tanggal'
          "
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              flat
              single-line
              solo
              outlined
              readonly
              hide-details
              class="ml-2"
              :background-color="isDisabledDate ? 'grey lighten-3' : ''"
              :disabled="isDisabledDate"
              v-bind="attrs"
              v-on="on"
              v-model="filters.endDate.formatted"
              prepend-inner-icon="mdi-calendar"
              placeholder="Pilih tanggal"
            />
          </template>
          <!-- :max="filter.type === 'Rentang Tanggal' ? endDate.raw : ''" -->
          <v-date-picker
            v-model="filters.endDate.raw"
            locale="id"
            scrollable
            @input="$refs.menu_enddate.save(formatDate(filters.endDate.raw))"
          ></v-date-picker>
        </v-menu>
      </div>
      <div class="d-flex align-center">
        <v-autocomplete
          append-icon="mdi-chevron-down"
          placeholder="Pilih filter"
          class="mr-2"
          item-text="name"
          item-value="id"
          dense
          outlined
          single-line
          hide-details
          :loading="isLoadingUnit"
          @change="resolveGetOrderHistory"
          :items="resource.unit"
          v-model="filters.unit"
        />
        <v-text-field
          dense
          single-line
          hide-details
          outlined
          style="min-width: 0; width: 20vw;"
          prepend-inner-icon="mdi-magnify"
          class="mr-2"
          placeholder="Cari jenis pemeriksaan atau no. order..."
          v-model="filters.search"
        />
        <v-btn
          color="primary"
          class="d-flex align-center text-capitalize"
          style="letter-spacing: .1px;"
          @click="openDialog('new-order')"
          dense
          depressed
          ><v-icon class="mr-1" small>mdi-plus</v-icon> permintaan baru</v-btn
        >
      </div>
    </div>
    <div class="main px-7 pt-5">
      <div class="table-header">
        <span>no</span>
        <span>tanggal order</span>
        <span>no registrasi</span>
        <span>no order</span>
        <span>jenis pemeriksaan</span>
        <span>petugas lab</span>
        <span>unit</span>
        <span>status</span>
        <div></div>
      </div>
      <div class="table-container">
        <v-progress-linear :indeterminate="true" v-if="isLoading" />
        <p class="grey--text mt-3" v-if="!table.items.length">
          Riwayat laboratorium tidak ditemukan
        </p>
        <div
          v-for="(item, index) in table.items"
          :key="index"
          class="table-row"
        >
          <span>{{ index + 1 }}</span>
          <span>{{ item.date }}</span>
          <span>{{ item.registrationNumber }}</span>
          <span>{{ item.orderNumber }}</span>
          <v-tooltip v-if="item.examinationType.length > 50" bottom>
            <template #activator="{ on: tooltip }">
              <span style="cursor: pointer" v-on="{ ...tooltip }">{{
                item.examinationsShow
              }}</span>
            </template>
            <span>{{ item.examinationType }}</span>
          </v-tooltip>
          <span v-else>{{ item.examinationsShow }}</span>
          <v-tooltip v-if="item.staff.length > 20" bottom>
            <template #activator="{ on: tooltip }">
              <span style="cursor: pointer" v-on="{ ...tooltip }">{{
                item.staffShow
              }}</span>
            </template>
            <span>{{ item.staff }}</span>
          </v-tooltip>
          <span v-else>{{ item.staff }}</span>
          <span>{{ item.unit }}</span>
          <div
            class="chip text-capitalize"
            :style="{
              color: item.status.color.text,
              backgroundColor: item.status.color.background,
            }"
          >
            {{ item.status.text }}
          </div>
          <div class="d-flex align-center">
            <v-btn
              text
              dense
              depressed
              single-line
              @click="openDetail(item)"
              color="primary"
              class="mr-2 text-capitalize"
              style="letter-spacing: .01px; font-size: .85vw;"
              >lihat detail</v-btn
            >
            <v-menu left :offset-x="true" :close-on-content-click="true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  text
                  fab
                  dense
                  depressed
                  single-line
                  small
                  ><v-icon color="#757575">mdi-dots-vertical</v-icon></v-btn
                >
              </template>
              <v-card class="text-start menu-selection">
                <div
                  @click="printOrder(item)"
                  :class="{ disabled: !item.isInputed }"
                >
                  <span>Print hasil</span>
                </div>
                <div @click="orderAsNewRequest(item)">
                  <span>Order sebagai permintaan baru</span>
                </div>
                <div
                  v-if="route === 'pendaftaran'"
                  @click="cancelOrder(item)"
                  :class="{ disabled: item.status.text !== 'belum diproses' }"
                >
                  <span>Batalkan permintaan</span>
                </div>
              </v-card>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog" persistent width="fit-content">
      <detail-and-result-lab-order
        v-if="dialog && selectedForm === 'detail-and-result'"
        @close-dialog="dialog = false"
        :patient-data="{
          ...patientData,
          unit: selectedOrder.unit,
          status: selectedOrder.status,
          isInputed: selectedOrder.isInputed,
        }"
      />
      <new-order-from-history
        :is-new-order="isNewOrder"
        @close-dialog="dialog = false"
        :patient-data="{
          ...patientData,
          unit: unit,
          status: selectedOrder.status,
        }"
        v-if="dialog && selectedForm === 'new-order'"
      />
    </v-dialog>
    <v-snackbar
      :timeout="4000"
      v-model="getSnackbar.show"
      :color="getSnackbar.color"
    >
      <div class="d-flex justify-space-between">
        <span class="mr-auto">{{ getSnackbar.text }}</span>
        <v-icon
          class="ml-auto"
          dark
          small
          @click="() => (getSnackbar.show = false)"
        >
          mdi-close
        </v-icon>
      </div>
    </v-snackbar>
  </v-card>
</template>

<script>
import Swal from 'sweetalert2';

import DetailAndResultLabOrder from './DetailAndResultLabOrder.vue';
import NewOrderFromHistory from './NewOrderFromHistory.vue';

import { createNamespacedHelpers } from 'vuex';
import printLaboratoryResult from '@/mixin/printLaboratoryResult.js';
import printMixin from '@/mixin/printMixin';
import formatMixin from '@/mixin/formatMixin';

const {
  mapGetters: patientGetters,
  mapMutations: patientMutations,
} = createNamespacedHelpers('PatientRegistration');
const {
  mapGetters: labGetters,
  mapMutations: labMutations,
  mapActions: labActions,
} = createNamespacedHelpers('ExaminationLaboratory');
const moment = require('moment-timezone');
const _ = require('lodash');
const { limitText } = require('@/helper');

// api
import {
  getOrderHistoryByIdEmr,
  deleteRegisterLab,
} from '../../../../fetchApi/laboratory';
import { getAllUnit } from '../../../../fetchApi/MasterData/Unit';

export default {
  props: {
    unit: {
      type: String,
      default: '',
    },
    noReg: {
      type: String,
      default: '',
    },
  },
  components: { DetailAndResultLabOrder, NewOrderFromHistory },
  mixins: [printLaboratoryResult, printMixin, formatMixin],
  name: 'ExaminationOrderHistory',
  data() {
    return {
      selectedForm: null,
      isNewOrder: false,
      selectedOrder: '',
      dialog: false,
      isLoading: false,
      menu: {
        startDate: false,
        endDate: false,
      },
      filters: {
        timeType: 'Semua Waktu',
        unit: 'Semua Unit',
        search: '',
        startDate: {
          raw: '',
          formatted: '',
        },
        endDate: {
          raw: '',
          formatted: '',
        },
      },
      resource: {
        unit: [],
        timeType: [
          'Semua Waktu',
          '30 Hari Terakhir',
          '7 Hari Terakhir',
          'Rentang Tanggal',
          'Per Tanggal',
        ],
      },
      table: {
        items: [],
      },
      isMultiOrder: false,
      isLoadingUnit: false,
    };
  },
  computed: {
    ...patientGetters(['getPatientRegistration']),
    ...labGetters([
      'getLabRegistration',
      'getPatientData',
      'getLabResultById',
      'getSnackbar',
      'getSelectedPatientIndex',
    ]),
    isHasUnconfirmedOrder() {
      return this.table.items
        .filter(
          arr =>
            arr.registrationNumber ===
            this.$store.getters.selectedPatient?.noRegist,
        )
        .some(item => !item.isConfirmed);
    },
    route: {
      get() {
        return this.$route.path.split('/')[1];
      },
    },
    isDisabledDate: {
      get() {
        return (
          this.filters.timeType === '30 Hari Terakhir' ||
          this.filters.timeType === '7 Hari Terakhir'
        );
      },
    },
    selectedPatinet: {
      get() {
        return { ...this.getSelectedPatient };
      },
    },
    patientData: {
      get() {
        if (this.route !== 'pendaftaran') {
          return {
            name: this.$store.getters.selectedPatient.meta.name,
            rmNumber: this.$store.getters.selectedPatient.rmNumber,
            birthDate: this.$store.getters.selectedPatient.meta.birthDate,
            age: this.$store.getters.selectedPatient.meta.age,
            gender:
              this.$store.getters.selectedPatient.meta.gender === 'Laki-laki',
            idEmr: this.$store.getters.selectedPatient.id_emr,
          };
        }
        if (!this.getPatientRegistration?.name) {
          return {
            name: this.getLabRegistration[this.getSelectedPatientIndex].name,
            rmNumber: this.getLabRegistration[this.getSelectedPatientIndex]
              .noRM,
            birthDate: moment(
              this.getLabRegistration[this.getSelectedPatientIndex].birthDate,
              ['DD/MM/YYYY', 'YYYY-MM-DD'],
            ).format('DD MMMM YYYY'),
            age: this.ageDuration(
              moment(
                this.getLabRegistration[this.getSelectedPatientIndex].birthDate,
                ['DD/MM/YYYY', 'YYYY-MM-DD'],
              ),
            ),
            gender: this.getLabRegistration[this.getSelectedPatientIndex]
              .gender,
            idEmr: this.getLabRegistration[this.getSelectedPatientIndex].idEMR,
          };
        }
        return {
          name: this.getPatientRegistration.name,
          rmNumber: this.getPatientRegistration.rmNumber,
          birthDate: moment(this.getPatientRegistration.birthDate, [
            'DD/MM/YYYY',
            'YYYY-MM-DD',
          ]).format('DD MMMM YYYY'),
          age: this.ageDuration(
            moment(this.getPatientRegistration.birthDate, [
              'DD/MM/YYYY',
              'YYYY-MM-DD',
            ]),
          ),
          gender: this.getPatientRegistration.gender,
          idEmr: this.getPatientRegistration.idEmr,
        };
      },
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.resolveGetOrderHistory();
        this.isNewOrder = false;
      }
    },
    'filters.search'() {
      this.searchData(this);
    },
    'filters.startDate.raw'() {
      if (this.filters.timeType === 'Per Tanggal') {
        this.resolveGetOrderHistory();
        return;
      }
      if (this.filters.endDate.raw) {
        this.resolveGetOrderHistory();
      }
    },
    'filters.endDate.raw'() {
      if (this.filters.startDate.raw) {
        this.resolveGetOrderHistory();
      }
    },
  },
  mounted() {
    this.clearSnackbar();
    this.resolveGetOrderHistory();
    this.resolveGetAllUnit();
  },
  beforeDestroy() {
    this.clearStatePatientRegistration();
    if (this.isMultiOrder) {
      this.clearSnackbar();
    }
  },
  methods: {
    ...patientMutations(['clearStatePatientRegistration']),
    ...labMutations([
      'setPatientData',
      'setInputOrderCheckedItems',
      'clearSnackbar',
      'setShowDialog',
      'setProvisionalDiagnosis',
      'setSnackbar',
    ]),
    ...labActions(['resolveGetLabResult']),
    async printOrder(item) {
      try {
        if (!item.isInputed) return;
        this.setPatientData({
          ...this.getPatientData,
          idLab: item.idLab,
        });
        if (!this.getLabResultById.patient) {
          await this.resolveGetLabResult();
        }
        const doc = this.printLabResult({
          doctor: this.getLabResultById.staff_request?.name,
          timeOrder: moment(this.getLabResultById.timestamps.created_at).format(
            'DD-MM-YYYY',
          ),
          timeFinish: moment(
            this.getLabResultById.timestamps.finished_at,
          ).format('DD-MM-YYYY'),
          name: this.getLabResultById.patient.name,
          address: this.formatAddress(this.getLabResultById.patient.address),
          guarantorType: this.getLabResultById.assurance,
          gender: this.getLabResultById.patient.gender
            ? 'Laki-laki'
            : 'Perempuan',
          birthDateAge: `${this.patientData.birthDate} (${this.patientData.age} Tahun)`,
          noLabRM: this.getLabResultById.patient.medical_record_number,
          testItem: this.getLabResultById.test_item,
          clinicalNotes: this.getLabResultById.clinical_notes,
          recommendation: this.getLabResultById.recommendation,
          timestamps: this.getLabResultById.timestamps,
          staff_request: this.getLabResultById.staff_request?.name,
        });
        this.printDocument(doc, {
          docName: 'Hasil Laboratorium',
          rmNumber: this.getLabResultById.patient.medical_record_number,
        });
      } catch (error) {
        return error;
      }
    },
    showOrderWarning() {
      Swal.fire({
        title:
          '<div style="font-family: Roboto, Serif; color: #222222; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Permintaan masih dalam proses</p></div>',
        iconHtml: '<span class="mdi mdi-alert-circle-outline"></span>',
        html:
          '<div style="text-transform: none; font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%;"><p>Anda belum dapat membuat permintaan baru</p><p>karena permintaan sebelumnya masih menunggu</p><p>konfirmasi oleh pihak lab. Silakan tunggu hingga</p><p>permintaan sebelumnya dikonfirmasi</p></div>',
        reverseButtons: true,
        customClass: {
          confirmButton: 'button-confirm',
        },
        confirmButtonText: 'Kembali',
      });
    },
    orderAsNewRequest(item) {
      if (this.isHasUnconfirmedOrder) {
        this.showOrderWarning();
        return;
      }
      this.setPatientData({
        ...this.getPatientData,
        idLab: item.idLab,
        status: item.status,
      });
      this.selectedOrder = {
        unit: item.unit,
        status: item.status,
        isInputed: item.isInputed,
      };
      this.setProvisionalDiagnosis(item.diagnosis);
      this.setInputOrderCheckedItems(item.examinationList);
      this.openDialog('new-order');
    },
    openDetail(item) {
      this.setPatientData({
        ...this.getPatientData,
        idLab: item.idLab,
        status: item.status,
      });
      this.selectedOrder = {
        unit: item.unit,
        status: item.status,
        isInputed: item.isInputed,
      };
      this.openDialog('detail-and-result');
    },
    openDialog(form) {
      if (form === 'new-order') {
        if (this.isHasUnconfirmedOrder) {
          this.showOrderWarning();
          return;
        }
        this.selectedOrder = {
          ...this.selectedOrder,
          unit: this.unit,
        };
        this.isNewOrder = true;
      }
      this.selectedForm = form;
      this.dialog = true;
    },
    async cancelOrder(item) {
      if (item.status.text !== 'belum diproses') return;
      const warningText = item.isMultiOrder
        ? '<div style="text-transform: none; font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%;"><p>Permintaan yang Anda batalkan akan dihapus</p></div>'
        : '<div style="text-transform: none; font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%;"><p>Jika Anda batalkan, permintaan ini akan dihapus</p><p>dan pendaftaran laboratorium pasien juga akan</p><p>dibatalkan</p></div>';
      Swal.fire({
        title:
          '<div style="font-family: Roboto, Serif; color: #222222; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Apakah Anda ingin membatalkan</p><p>permintaan ini?</p></div>',
        iconHtml: '<span class="mdi mdi-help-circle-outline"></span>',
        html: warningText,
        showCancelButton: true,
        reverseButtons: true,
        customClass: {
          confirmButton: 'button-confirm',
          cancelButton: 'button-cancel',
        },
        confirmButtonText: 'Yakin',
        cancelButtonText: 'Batal',
      }).then(async result => {
        if (result.isConfirmed) {
          await deleteRegisterLab(item.idLab);
          this.resolveGetOrderHistory();
          this.isMultiOrder = item.isMultiOrder;
          this.setSnackbar({
            show: true,
            color: 'success',
            text: 'Permintaan berhasil dibatalkan',
          });
          if (!item.isMultiOrder) {
            this.setSnackbar({
              show: true,
              color: 'success',
              text: 'Permintaan dan registrasi pasien berhasil dibatalkan',
            });
            this.close();
          }
        }
      });
    },
    onChangeTimeType() {
      switch (this.filters.timeType) {
        case '30 Hari Terakhir':
          this.filters.startDate = {
            raw: moment()
              .subtract(30, 'days')
              .format('YYYY-MM-DD'),
            formatted: moment()
              .subtract(30, 'days')
              .format('DD-MM-YYYY'),
          };
          this.filters.endDate = {
            raw: moment().format('YYYY-MM-DD'),
            formatted: moment().format('DD-MM-YYYY'),
          };
          break;
        case '7 Hari Terakhir':
          this.filters.startDate = {
            raw: moment()
              .subtract(7, 'days')
              .format('YYYY-MM-DD'),
            formatted: moment()
              .subtract(7, 'days')
              .format('DD-MM-YYYY'),
          };
          this.filters.endDate = {
            raw: moment().format('YYYY-MM-DD'),
            formatted: moment().format('DD-MM-YYYY'),
          };
          break;
        case 'Rentang Tanggal':
        case 'Per Tanggal':
          this.filters.startDate = {
            raw: '',
            formatted: '',
          };
          this.filters.endDate = {
            raw: '',
            formatted: '',
          };
          break;
        case 'Semua Waktu':
          this.filters.startDate = {
            raw: '',
            formatted: '',
          };
          this.filters.endDate = {
            raw: '',
            formatted: '',
          };
          this.resolveGetOrderHistory();
          break;
      }
    },
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
    },
    close() {
      this.clearStatePatientRegistration();
      this.$emit('close-dialog');
      this.setShowDialog(false);
    },
    searchData: _.debounce(v => {
      // eslint-disable-next-line no-param-reassign
      v.resolveGetOrderHistory();
    }, 650),
    async resolveGetAllUnit() {
      this.isLoadingUnit = true;
      this.resource.unit = ['Semua Unit'];
      try {
        const response = await getAllUnit();
        this.resource.unit = [
          'Semua Unit',
          ...response.data.map(item => ({
            name: item.name,
            id: item._id,
          })),
        ];
        if (response) {
          this.isLoadingUnit = false;
        }
      } catch {
        this.resource.unit = ['Semua Unit'];
        this.isLoadingUnit = false;
      }
    },
    translateStatus(status) {
      switch (status) {
        case 'unprocess':
          return {
            text: 'belum diproses',
            color: { background: '#ffebee', text: '#d32f2f' },
          };
        case 'inprocess':
          return {
            text: 'sedang diproses',
            color: { background: '#fffbea', text: '#e26c00' },
          };
        case 'finish':
          return {
            text: 'selesai',
            color: { background: '#e7f8ec', text: '#2b9c4d' },
          };
      }
    },
    async resolveGetOrderHistory() {
      try {
        this.isLoading = true;
        const data = {
          params: {
            startDate: this.filters.startDate?.raw || '',
            endDate:
              this.filters.timeType === 'Per Tanggal'
                ? this.filters.startDate?.raw || ''
                : this.filters.endDate?.raw || '',
            unit: this.filters.unit === 'Semua Unit' ? '' : this.filters?.unit,
            search: this.filters.search,
          },
          idEmr: this.patientData.idEmr,
        };

        const response = await getOrderHistoryByIdEmr(data);
        this.table.items = response.data.data.map(item => ({
          idLab: item.id_lab,
          date: moment(item.date).format('DD/MM/YYYY, HH:mm'),
          registrationNumber: item.regNumber,
          orderNumber: item.orderNumber,
          examinationType: item.examinations.map(d => d.name).join(', '),
          examinationsShow: limitText(
            item.examinations.map(d => d.name).join(', '),
            50,
          ),
          examinationList: item.examinations,
          diagnosis: item.diagnosis,
          staff: item.staffLab,
          staffShow: limitText(item.staffLab, 20),
          unit: item.unit,
          isInputed: item.isInputed,
          isMultiOrder: item.isMultiOrder,
          isConfirmed: item.isConfirmed,
          status: this.translateStatus(item.status),
        }));
      } catch (error) {
        this.table.items = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  p:nth-of-type(even) {
    margin-right: 2rem;
  }
  p:nth-of-type(odd) {
    margin-right: 1.8rem;
    color: #9e9e9e;
  }
}

.main {
  flex: 1;

  .table-header {
    display: grid;
    grid-template-columns: 3% repeat(3, 10%) 23% 14% 10% 9% 8%;
    text-align: left;
    padding: 0.6rem 1rem;
    font-size: 0.85vw;
    text-transform: capitalize;
    color: #9e9e9e;
    border-bottom: 1px solid #e0e0e0;
    background-color: #fafafa;
  }

  .table-container {
    max-height: 70vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 9px;
      border-radius: 5px;
      background-color: rgb(168, 168, 168);
    }
    &::-webkit-scrollbar-thumb {
      width: 9px;
      border-radius: 5px;
      background-color: rgb(98, 98, 98);
    }

    .table-row {
      display: grid;
      grid-template-columns: 3% repeat(3, 10%) 23% 14% 10% 9% 8%;
      align-items: center;
      padding: 0.6rem 1rem;
      text-align: left;
      font-size: 0.8vw;
      border-bottom: 1px solid #ededed;

      .chip {
        color: #2b9c4d;
        padding: 0.3rem 0.8rem;
        background-color: #e7f8ec;
        border-radius: 7px;
        align-items: center;
        width: fit-content;
        height: fit-content;
        display: flex;
      }
    }
  }
}

.menu-selection {
  div {
    padding: 0.5rem 1rem;

    &.disabled {
      color: #9e9e9e;
    }
  }
  div:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
}

::v-deep .v-list-item .v-list-item__content {
  line-height: 1.1;
  flex: 1 0 100%;
  text-align: start;
}
</style>
